'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Menu = function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu() {
    _classCallCheck(this, Menu);

    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this));

    _this.setGoal = _this.setGoal.bind(_this);
    _this.logout = _this.logout.bind(_this);
    return _this;
  }

  _createClass(Menu, [{
    key: 'setGoal',
    value: function setGoal() {
      var _this2 = this;

      var goal = Math.abs(parseInt(prompt('Please enter your calorie goal', this.props.user.goal)));
      if (goal) {
        _client2.default.service('users').patch(this.props.user.id, {
          goal: goal,
          token: _client2.default.get('token')
        }).then(function (user) {
          _this2.props.updateUser(user);
        });
      }
    }
  }, {
    key: 'logout',
    value: function logout() {
      _client2.default.logout().then(function () {
        window.location.reload();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;
      var currentUser = this.props.currentUser;
      var observing = user.id !== currentUser.id;
      var items = [];
      if (observing) {
        items.push(_react2.default.createElement(
          'li',
          { key: 'observing' },
          _react2.default.createElement(
            'i',
            null,
            'Viewing'
          ),
          ' ',
          user.email
        ));
      } else {
        items.push(_react2.default.createElement(
          'li',
          { key: 'hello' },
          'Hello ',
          currentUser.email
        ));
      }
      items.push(_react2.default.createElement(
        'li',
        { key: 'goal', onMouseDown: this.setGoal },
        _react2.default.createElement(
          'a',
          { href: '#' },
          'Goal'
        ),
        ': ',
        user.goal,
        ' cal'
      ));
      switch (currentUser.role) {
        case 'admin':
          // if (this.props.user.id !== this.props.currentUser.id) {
          //   items.push( <li key='resetUser'><a href='#' onClick={this.resetUser}>Stop viewing</a></li> )
          // }
          items.push(_react2.default.createElement(
            'li',
            { key: 'userlist' },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.toggleMode },
              'Users'
            )
          ));
          items.push(_react2.default.createElement(
            'li',
            { key: 'meallist' },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.toggleMode },
              'Meals'
            )
          ));
          break;
        case 'manager':
          items.push(_react2.default.createElement(
            'li',
            { key: 'userlist' },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.toggleMode },
              'Users'
            )
          ));
          items.push(_react2.default.createElement(
            'li',
            { key: 'meallist' },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.toggleMode },
              'Meals'
            )
          ));
        case 'user':
          break;
      }
      items.push(_react2.default.createElement(
        'li',
        { key: 'logout' },
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.logout },
          'Logout'
        )
      ));

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          { className: 'menu' },
          items
        )
      );
    }
  }]);

  return Menu;
}(_react2.default.Component);

exports.default = Menu;


//////////////////
// WEBPACK FOOTER
// ./client/components/Menu.jsx
// module id = 220
// module chunks = 0